'use client'

import { useEffect, useRef, useState } from 'react'

// The studio's three days against five hours, to scale. The other-tools bar is split into its
// three days (as the launch video draws it); Martini's bar starts as long and shrinks to its real
// length when the chart scrolls into view. Under reduced motion it is drawn already shrunk.
const OTHER_HOURS = 72
const MARTINI_HOURS = 5

export function TimeSaved() {
  const ref = useRef<HTMLDivElement>(null)
  const [shrunk, setShrunk] = useState(false)

  useEffect(() => {
    const el = ref.current
    if (!el) return
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setShrunk(true)
          observer.disconnect()
        }
      },
      { threshold: 0.6 },
    )
    observer.observe(el)
    return () => observer.disconnect()
  }, [])

  const martiniWidth = shrunk ? (MARTINI_HOURS / OTHER_HOURS) * 100 : 100

  return (
    <div ref={ref} className="rounded-2xl border border-white/[0.09] bg-white/[0.02] p-6 md:p-7">
      <div className="space-y-6" aria-hidden>
        <div>
          <div className="flex items-baseline justify-between text-[14px]">
            <span className="text-white/55">Other tools</span>
            <span className="tabular-nums text-white/55">3 days</span>
          </div>
          <div className="mt-2 grid grid-cols-3 gap-1">
            {['Day 1', 'Day 2', 'Day 3'].map(day => (
              <div
                key={day}
                className="flex h-7 items-center rounded-md bg-white/[0.12] px-2 text-[11px] text-white/50"
              >
                {day}
              </div>
            ))}
          </div>
        </div>
        <div>
          <div className="flex items-baseline justify-between text-[14px]">
            <span className="font-medium text-white">Martini</span>
            <span className="font-medium tabular-nums text-white">5 hours</span>
          </div>
          <div className="mt-2 h-7 rounded-md bg-white/[0.04]">
            <div
              className="h-7 rounded-md bg-white transition-[width] duration-[1600ms] ease-[cubic-bezier(.6,0,.2,1)] motion-reduce:transition-none"
              style={{ width: `${martiniWidth}%` }}
            />
          </div>
        </div>
      </div>
      {/* The bars first, then what they add up to. */}
      <div className="mt-7 border-t border-white/[0.08] pt-5">
        <p className="text-[13px] text-white/50">Time for the same work</p>
        <p className="mt-1 text-[28px] font-semibold tracking-[-0.025em] text-white md:text-[32px]">
          3 days <span className="text-white/35">→</span> 5 hours
        </p>
      </div>
    </div>
  )
}
